import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './index.css';
import { ArrowDownIcon } from '../../common/icons/arrow_down_icon';

interface IBlockClipOwnProps {
  size: number;
  text: string;
  textClassName?: string;
}

interface IBlockClipState {
  isOpen: boolean;
}

export class BlockClip extends React.Component<React.PropsWithChildren<IBlockClipOwnProps>, IBlockClipState> {
  public state = {
    isOpen: false,
  };
  public render() {
    const { children, size, text, textClassName } = this.props;
    const { isOpen } = this.state;

    if (!children) {
      return null;
    }

    if (Array.isArray(children) && children.length > size) {
      return (
        <>
          {children.slice(0, size)}
          <div {...mergeStyles(styles['container'], isOpen && styles['container--open'])}>
            {children.slice(size, children.length)}
          </div>
          {!isOpen && children.length > size && (
            <div {...mergeStyles(styles['more'], textClassName)} onClick={this.open}>
              <span className={styles['text']}>{text}</span>
              <ArrowDownIcon />
            </div>
          )}
        </>
      );
    } else {
      return children;
    }
  }

  private open = () => {
    this.setState({ isOpen: true });
  };
}
